/**
 * 滚动到视图区
 * 使用了一个很棒的库：https://github.com/stipsan/scroll-into-view-if-needed
 *
 * 1 针对 behavior === 'smooth' 时做了定制
 * 2 同时增强了对 duration(秒) 的支持
 */
import innerScrollIntoView from 'smooth-scroll-into-view-if-needed'
import { TweenLite } from 'gsap'
import _ from 'lodash'

export default function scrollIntoView(target, options) {
  let { behavior, duration } = options
  if (behavior !== 'instant' && !_.isFunction(behavior)) {
    behavior = instructions => {
      if (!instructions.length) {
        return
      }
      const [{ el, left, top }] = instructions
      TweenLite.to(el, duration || 0.3, {
        scrollLeft: left,
        scrollTop: top,
      })
    }
  }

  innerScrollIntoView(target, _.assign(options, {
    behavior,
  }))
}
